import angular from 'angular';

import './store-date-selector.css';

import StoreDateSelectorController from './store-date-selector.controller';
import storeDateSelector from './store-date-selector';
import Session from '../../service/session';
import User from '../../service/user';

export default angular.module('directive.store-date-selector', [Session, User])
	.controller('StoreDateSelectorController', StoreDateSelectorController)
	.directive('storeDateSelector', storeDateSelector)
	.name;



// WEBPACK FOOTER //
// ./src/directive/store-date-selector/index.js